import { GraphqlQueryResponse } from '~/types/apollo-graphql-types'
import {
  ActiveThirdPartyVulnerabilitiesT,
  IHandledResponse,
  IReportInfo,
  ReportMeta,
  ReportPageT
} from '~/types/reportTypes'
import { ActiveThirdPartyVulnerabilitiesReportItem } from '~/types/types'
import { getFormattedDistributionChartData } from '~/utils/reports'

const reportKey = ReportPageT.ACTIVE_THIRD_PARTY_VULNERABILITIES

export default {
  key: reportKey,
  query: (filter?: ActiveThirdPartyVulnerabilitiesT) => {
    return filter === ActiveThirdPartyVulnerabilitiesT.REACHABILITY
      ? 'activeThirdPartyVulnerabilitiesByReachability'
      : 'activeThirdPartyVulnerabilitiesBySeverity'
  },
  componentName: 'PinnedActive3rdPartyVulns',
  handleResponse: (response: GraphqlQueryResponse, filter?: ActiveThirdPartyVulnerabilitiesT) => {
    const handledResponse: IHandledResponse = {
      label: ReportMeta[reportKey].title
    }

    // Get the data based on the filter type
    let vulnerabilityData: Array<ActiveThirdPartyVulnerabilitiesReportItem> = []

    if (filter === ActiveThirdPartyVulnerabilitiesT.SEVERITY) {
      const rawData = response.data.activeThirdPartyVulnerabilitiesBySeverity || []
      vulnerabilityData = rawData.filter(Boolean) as ActiveThirdPartyVulnerabilitiesReportItem[]
    } else if (filter === ActiveThirdPartyVulnerabilitiesT.REACHABILITY) {
      const rawData = response.data.activeThirdPartyVulnerabilitiesByReachability || []
      vulnerabilityData = rawData.filter(Boolean) as ActiveThirdPartyVulnerabilitiesReportItem[]
    }

    // Calculate total vulnerabilities
    const totalVulns = vulnerabilityData.reduce((sum, item) => sum + (item.value || 0), 0)
    handledResponse.value = totalVulns
    handledResponse.valueLabel = totalVulns === 1 ? 'vulnerability' : 'vulnerabilities'

    // Pass the vulnerability data to the widget
    handledResponse.vulnerabilityData = vulnerabilityData

    // Format the data for chart display if we have data
    if (vulnerabilityData.length > 0) {
      // Convert to the format expected by getFormattedDistributionChartData
      const chartData = vulnerabilityData.reduce((acc, item) => {
        if (item.name && item.value) {
          acc[item.name] = [item.value] // Array format expected by the util
        }
        return acc
      }, {} as Record<string, number[]>)

      if (Object.keys(chartData).length > 0) {
        const [dataset, othersDatasetNames] = getFormattedDistributionChartData(
          chartData,
          reportKey
        )

        handledResponse.datasets = dataset
        handledResponse.othersDatasetNames = othersDatasetNames
      }
    }

    return handledResponse
  }
} as IReportInfo
